export default __webpack_public_path__ + "static/media/logo_new_yun.80683323.svg";